import { ComponentType, lazy, LazyExoticComponent } from 'react';
import { getAllPermissionRolesForUserLevel, PERMISSIONROLECONSTANTS } from '../features/utils/utils.action';
import { devicePermissions } from '../views/Main/Inventory/Devices/Devices';
import { fulfillmentOrderPermissions } from '../views/Main/Inventory/FulfillmentOrders/FulfillmentOrders';
import { orderPermissions } from '../views/Main/Inventory/Orders/Order';
import { RouteComponentProps } from 'react-router-dom';
import { ataPermissions } from '../views/Main/ATAs/ATA.permissions';
import { ulareCentralStationPermissions } from '../views/Main/ULARECentralStations/ULARECentralStation.permissions';
import { NotificationData } from '../hooks/useNotificationData';
import { serviceTypePermissions } from '../views/Main/ServiceTypes/ServiceType.permissions';
import { rmaOrderPermissions } from '../views/Main/RMAOrders/utils/rmaOrders.utils';
import { priPermissions } from '../views/Main/PRIs/pri.permissions';
import { CDRPermissions } from '../views/Main/CDRs/cdr.permission';
import { GlobalScope, OrgScope } from '../types/authorization/authorization.types';
import { didPermissions } from '../views/Main/DIDs/DID.permissions';

export const getDashboardPath = '/dashboard';
export const getNOCPath = `${getDashboardPath}/noc`;
export const getDashboardOverviewPath = `${getDashboardPath}/overview`;
export const getDashboardMapPath = `${getDashboardPath}/map`;
export const getCellTowerReportsPath = `${getDashboardPath}/cell-tower-reports`;
export const getCellTowerReportDetailsPath = `${getCellTowerReportsPath}/:id`;
export const getJotFormOrderPage = `${getDashboardPath}/jot-form-order`;
export const getOtherPath = '/other';
export const getSupportPath = '/support';
/** @deprecated */
export const getOrdersDetailsPath = `${getDashboardPath}/orders/:id`;
export const getAlertLogsListPath = `${getDashboardPath}/alert-logs`;
export const getSalesReportsPath = `${getDashboardPath}/sales-reports`;

export const getInventoryPath = '/inventory';
export const getInventoryMicroserviceWarehousePath = `${getInventoryPath}/microservice-warehouse`;
export const getInventoryMicroserviceWarehouseDetailsPath = `${getInventoryPath}/microservice-warehouse/:id`;
export const getInventoryReportPath = `${getInventoryPath}/report`;
export const getInventoryItemsListPath = `${getInventoryPath}/items`;
export const getInventoryATAItemDetailsPath = `${getInventoryPath}/items/ata/:id`;
export const getInventoryBatteryItemDetailsPath = `${getInventoryPath}/items/battery/:id`;
export const getInventoryDialerItemDetailsPath = `${getInventoryPath}/items/dialer/:id`;
export const getInventoryEnclosureItemDetailsPath = `${getInventoryPath}/items/enclosure/:id`;
export const getInventoryPowerCycleItemDetailsPath = `${getInventoryPath}/items/power-cycle/:id`;
export const getInventoryRouterItemDetailsPath = `${getInventoryPath}/items/router/:id`;
export const getInventorySimItemDetailsPath = `${getInventoryPath}/items/sim/:id`;
export const getInventorySmartphoneItemDetailsPath = `${getInventoryPath}/items/smartphone/:id`;
export const getInventoryOrdersListPath = `${getInventoryPath}/fulfillment-orders`;
export const getInventoryCreateOrderDetailsPath = `${getInventoryPath}/fulfillment-orders/0`;
export const getInventoryModifyOrderDetailsPath = `${getInventoryPath}/fulfillment-orders/:id`;
export const getNewOrderListPath = `${getInventoryPath}/orders`;
export const getNewOrderDetailsPath = `${getInventoryPath}/orders/:id`;
export const getOrderTemplateListPath = `${getInventoryPath}/order-templates`;
export const getOrderTemplateDetailsPath = `${getInventoryPath}/order-templates/:id`;
export const getAccessoryBundlesListPath = `${getInventoryPath}/accessory-bundles`;
export const getRMAListPath = `${getInventoryPath}/rma`;
export const getRMADetailsPath = `${getRMAListPath}/:id`;
export const getOrderReportDashboardPath = `${getInventoryPath}/order-report/overview`;
export const getDeviceReportDashboardPath = `${getInventoryPath}/device-report/overview`;

export const getOrganizationsPath = '/organizations';
export const getOrganizationListPath = `${getOrganizationsPath}/organizations`;
export const getOrganizationDetailsPath = `${getOrganizationListPath}/:id`;
export const getLocationListPath = `${getOrganizationsPath}/locations`;
export const getLocationsBulkDetailsPath = `${getOrganizationsPath}/locations/bulk`;
export const getLocationDetailsPath = `${getLocationListPath}/:id`;
export const getUserListPath = `${getOrganizationsPath}/users`;
export const getUserDetailsPath = `${getUserListPath}/:id`;
export const getUsersBulkDetailsPath = `${getOrganizationsPath}/users/bulk`;

export const getServicesPath = '/services';
export const getServiceListPath = `${getServicesPath}/services`;
export const getServiceDetailsPath = `${getServiceListPath}/:id`;
export const getServiceTypeListPath = `${getServicesPath}/service-types`;
export const getServiceTypeDetailsPath = `${getServiceTypeListPath}/:id`;
export const getContractsListPath = `${getServicesPath}/contracts`;
export const getContractDetailsPath = `${getContractsListPath}/:id`;
export const getContractLogsPath = `${getContractsListPath}/:id/logs`;
export const getServiceOrdersListPath = `${getServicesPath}/service-orders`;
export const getServiceOrderDetailsPath = `${getServiceOrdersListPath}/:id`;
export const getRevIoFieldIdsListPath = `${getServicesPath}/revio-field-id`;
export const getFullServiceInstallationReportPath = '/service-calls/full-service-installation-report';
export const getServiceCallsRequestListPath = '/service-calls/service-call-requests';
export const getServiceCallReportPath = '/service-calls/reporting';
export const getServiceCallsRequestDetailsPath = `${getServiceCallsRequestListPath}/:id`;
export const getTechniciansListPath = '/service-calls/technicians';
export const getServiceOrganizationsListPath = '/service-calls/service-organizations';
export const getChecklistTemplatesPath = '/service-calls/checklist-templates';
export const getChecklistTemplateDetailsPath = `${getChecklistTemplatesPath}/:id`;

export const getTelcoPath = '/telco';
export const getPBXListPath = `${getTelcoPath}/pbxs`;
export const getPBXDetailsPath = `${getPBXListPath}/:id`;
export const getPBXExtensionsListPath = `${getTelcoPath}/pbx-extensions`;
export const getPBXExtensionDetailsPath = `${getPBXExtensionsListPath}/:id`;
export const getDIDListPath = `${getTelcoPath}/dids`;
export const getDIDDetailsPath = `${getDIDListPath}/:id`;
export const getCreateDIDDetailsPath = `${getDIDListPath}/create`;
export const getDIDBulkDetailsPath = `${getDIDListPath}/bulk`;
export const getCdrsListPath = `${getTelcoPath}/cdrs`;
export const getCSRPCdrsListPath = `${getCdrsListPath}/csrp`;
export const getNetsapiensCdrsListPath = `${getCdrsListPath}/netsapiens`;
export const getMegaSwitchCdrsListPath = `${getCdrsListPath}/mega-switch`;
export const getCdrsSettingsPath = `${getTelcoPath}/cdr-settings`;
export const getDialerLogsListPath = `${getTelcoPath}/dialer-logs`;
export const getPortingDetailsPath = `${getTelcoPath}/porting/:id`;
export const getCreatePortingDetailsPath = `${getTelcoPath}/porting/0`;
export const getPortingListPath = `${getTelcoPath}/porting`;
export const getPortingLogsPath = `${getTelcoPath}/porting/:id/logs`;
export const getContactIDMessagesPath = `${getTelcoPath}/contact-id-messages`;
export const getPRIListPath = `${getTelcoPath}/pri`;
export const getPRIDetailsPath = `${getTelcoPath}/pri/:id`;

export const getULAREPath = '/ulare';
export const getMegaswitchPath = '/megaswitch';
export const getMegaswitchInstancesListPath = `${getMegaswitchPath}/instances`;
export const getMegaswitchInstanceDetailsPath = `${getMegaswitchInstancesListPath}/:id`;
export const getMegaswitchDomainsListPath = `${getMegaswitchPath}/domains`;
export const getMegaswitchCarriersListPath = `${getMegaswitchPath}/carriers`;
export const getMegaswitchDidsListPath = `${getMegaswitchPath}/dids`;
export const getMegaswitchUsersListPath = `${getMegaswitchPath}/users`;
export const getMegaswitchOutboundRoutesListPath = `${getMegaswitchPath}/outbound-routes`;
export const getMegaswitchCoresListPath = `${getMegaswitchPath}/cores`;

export const getConnectivityPath = '/connectivity';
export const getCellularListPath = `${getConnectivityPath}/cellular`;
export const getWirelineListPath = `${getConnectivityPath}/wireline`;
export const getLEOListPath = `${getConnectivityPath}/leo`;
export const getSimsListPath = `${getCellularListPath}/tc-sims`;
export const getFiberCircuitsListPath = `${getCellularListPath}/fiber-circuits`;
export const getFiberCircuitDetailsPath = `${getFiberCircuitsListPath}/:id`;
export const getStarlinksListPath = `${getLEOListPath}/starlinks`;
export const getStarlinkDetailsPath = `${getStarlinksListPath}/:id`;
export const getRoutersBulkDetailsPath = `${getConnectivityPath}/routers/bulk`;
export const getSimsDetailsPath = `${getSimsListPath}/:id`;

export const getEquipmentsPath = '/equipments';
export const getEquipmentGroupListPath = `${getEquipmentsPath}/groups`;
export const getEquipmentGroupDetailsPath = `${getEquipmentGroupListPath}/:id`;
export const getRouterListPath = `${getEquipmentsPath}/routers`;
export const getSyncRoutersListPath = `${getEquipmentsPath}/sync-routers`;
export const getSyncGSATAsListPath = `${getEquipmentsPath}/sync-gs-atas`;
export const getRouterDetailsPath = `${getRouterListPath}/:id`;
export const getBatteryListPath = `${getEquipmentsPath}/batteries`;
export const getBatteriesBulkDetailsPath = `${getEquipmentsPath}/batteries/bulk`;
export const getBatteryDetailsPath = `${getBatteryListPath}/:id`;
export const getATAListPath = `${getEquipmentsPath}/atas`;
export const getACSATAProfilesListPath = `${getEquipmentsPath}/acs-ata-profiles`;
export const getACSATAProfileDetailsPatch = `${getACSATAProfilesListPath}/:id`;
export const getATAGrandstreamPath = `${getATAListPath}-grandstream`;
export const getATACVACSPath = `${getATAListPath}-vacs`;
export const getATAACSPath = `${getATAListPath}-acs`;
export const getPotscastPath = `${getATAListPath}-potscast`;
export const getATAGrandstreamDetailsPath = `${getATAGrandstreamPath}/:id`;
export const getATAVACSDetailsPath = `${getATACVACSPath}/:id`;
export const getATAACSDetailsPath = `${getATAACSPath}/:id`;
export const getPotscastDetailsPath = `${getPotscastPath}/:id`;
export const getATABulkDetailsPath = `${getATAListPath}/bulk`;
export const getATAOrgTemplatesListPath = `${getEquipmentsPath}/ata-org-templates`;
export const getATAOrgTemplateDetailsPath = `${getATAOrgTemplatesListPath}/:id`;
export const getATABaseTemplatesListPath = `${getEquipmentsPath}/ata-base-templates`;
export const getATABaseTemplateDetailsPath = `${getATABaseTemplatesListPath}/:id`;
export const getATATypeListPath = `${getEquipmentsPath}/ata-types`;
export const getATATypeDetailsPath = `${getATATypeListPath}/:id`;
export const getGdmsCallbackLogsPath = `${getEquipmentsPath}/atas/statusLogs`;
export const getActionLogsPath = `${getEquipmentsPath}/ata-logs`;
export const getDialersListPath = `${getEquipmentsPath}/dialers`;
export const getDialerDetailsPath = `${getDialersListPath}/:id`;
export const getDialersBulkDetailsPath = `${getEquipmentsPath}/dialers/bulk`;
export const getEnclosuresListPath = `${getEquipmentsPath}/enclosures`;
export const getEnclosuresDetailsPath = `${getEquipmentsPath}/enclosures/:id`;
export const getEnclosuresBulkDetailsPath = `${getEquipmentsPath}/enclosures/bulk`;
export const getPowerCyclesListPath = `${getEquipmentsPath}/power-cycles`;
export const getPowerCyclesDetailsPath = `${getEquipmentsPath}/power-cycles/:id`;
export const getPowerCyclesBulkDetailsPath = `${getEquipmentsPath}/power-cycles/bulk`;
export const getPRIDevicesListPath = `${getEquipmentsPath}/pri-devices`;
export const getPRIDeviceDetailsPath = `${getPRIDevicesListPath}/:id`;
export const getSmartphonesListPath = `${getEquipmentsPath}/smartphones`;
export const getSmartphoneDetailsPath = `${getSmartphonesListPath}/:id`;

export const getLegalPage = '/legal';
export const getServiceLevelAgreementPage = '/sla';
export const getSupportServicesPage = '/ss';
export const getPrivacyPolicyPage = '/pp';
export const getAcceptableUsePolicyPage = '/aup';
export const get911TermsAndConditionsPage = '/911';
export const getPricingPage = '/pricing';
export const getMsaPage = '/msa';

export const getDocsPath = '/docs';
export const getPotsPortalPath = 'http://docs.potsportal.co/';
export const getCustomerApiDocsPath = `${getDocsPath}/potsportal-customer-api`;
export const getReleaseNotesPath = '/release-notes';
export const getSingleReleaseNotesPath = `${getReleaseNotesPath}/:id`;

export const getDataPlanTypeListPath = `${getOtherPath}/data-plan-types`;
export const getDataPlanTypeDetailsPath = `${getDataPlanTypeListPath}/:id`;
export const getDataPlanListPath = `${getOtherPath}/data-plans`;
export const getDataPlanDetailsPath = `${getDataPlanListPath}/:id`;
export const getCountriesListPath = `${getOtherPath}/countries`;
export const getCellTowersListPath = `${getOtherPath}/cell-towers`;
export const getULARECentralStationsListPath = `${getULAREPath}/central-stations`;
export const getULAREAlarmsListPath = `${getULAREPath}/alarms`;
export const getULARECentralStationDetailsPath = `${getULARECentralStationsListPath}/:id`;
export const getCountriesDetailsPath = `${getOtherPath}/countries/:id`;
export const getAuditLogsListPath = `${getOtherPath}/audit-logs`;
export const getAsyncTasksListPath = `${getOtherPath}/async-tasks`;
export const getErrorLogsListPath = `${getOtherPath}/error-logs`;
export const getIssueTrackerListPath = `${getOtherPath}/issue-tracker-items`;
export const getIssueTrackerDetailsPath = `${getIssueTrackerListPath}/:id`;
export const getRevioVerificationReportsPath = `${getOtherPath}/revio-verification-reports`;
export const getAccessAndVisibilityPath = '/access-visibility';
export const getBrandsListPath = `${getOtherPath}/brands`;
export const getBrandDetailsPath = `${getBrandsListPath}/:id`;
export const getModelsListPath = `${getOtherPath}/models`;
export const getModelDetailsPath = `${getModelsListPath}/:id`;
export const getLeadsListPath = `${getOtherPath}/leads`;
export const getLeadLogsListPath = `${getOtherPath}/lead-logs`;
export const getPotsRetirementNoticesListPath = `${getOtherPath}/pots-retirement-notices`;

export const getPermissionsPath = '/permissions';
export const getOrgRolesListPath = `${getPermissionsPath}/org-roles`;
export const getOrgRoleDetailsPath = `${getOrgRolesListPath}/:id`;
export const getGlobalRolesListPath = `${getPermissionsPath}/global-roles`;
export const getGlobalRoleDetailsPath = `${getGlobalRolesListPath}/:id`;

export const getTicketListPath = `${getSupportPath}/tickets`;
export const getTicketDetailsPath = `${getTicketListPath}/:id`;
export const getSecureALARMManager = '/secureAlarmManager';
export const getSecureALARMManagerBuckets = `${getSecureALARMManager}/buckets`;

export const getSecureALARMManagerBucketDetails = `${getSecureALARMManagerBuckets}/:id`;
export const getSecureALARMManagerDids = `${getSecureALARMManager}/dids`;
export const getSecureALARMManagerDidsBulk = `${getSecureALARMManager}/dids/bulk`;

export const getBillProfilesListPath = `${getOtherPath}/bill-profiles`;
export const getBillProfileDetailsPath = `${getBillProfilesListPath}/:id`;
export const getBillingCredentialsListPath = `${getOtherPath}/billing-credentials`;

const Dashboard = lazy(() => import('../views/Main/Dashboard/Dashboard'));
const NOC = lazy(() => import('../views/Main/NOC/NOC'));
const Map = lazy(() => import('../views/Main/Map/Map'));
const Order = lazy(() => import('../views/Main/Order/Order'));
/** @deprecated */
const OrderDetails = lazy(() => import('../views/Main/Orders/OrderDetails/OrderDetails'));
const AlertLogsList = lazy(() => import('../views/Main/AlertLogs/AlertLogs/AlertLogs'));
const SalesReports = lazy(() => import('../views/Main/SalesReports/SalesReports'));

const OrderTemplateDetails = lazy(
  () => import('../views/Main/Inventory/OrderTemplates/OrderTemplateDetails/OrderTemplateDetails')
);
const OrderTemplatesList = lazy(
  () => import('../views/Main/Inventory/OrderTemplates/OrderTemplatesList/OrderTemplatesList')
);
const NewOrderDetails = lazy(() => import('../views/Main/Inventory/Orders/OrderDetails/OrderDetails'));
const OrdersList = lazy(() => import('../views/Main/Inventory/Orders/OrdersList/OrdersList'));

const OrganizationsList = lazy(() => import('../views/Main/Organizations/OrganizationsList/OrganizationsList'));
const OrganizationDetails = lazy(() => import('../views/Main/Organizations/OrganizationDetails/OrganizationDetails'));
const LocationsList = lazy(() => import('../views/Main/Locations/LocationsList/LocationsList'));
const LocationDetails = lazy(() => import('../views/Main/Locations/LocationDetails/LocationDetails'));
const LocationsBulk = lazy(() => import('../views/Main/Locations/LocationsBulk/LocationsBulk'));
const MicroserviceWarehousesList = lazy(
  () => import('../views/Main/Inventory/Warehouses/MicroserviceWarehousesList/MicroserviceWarehousesList')
);
const MicroserviceWarehouseDetails = lazy(
  () => import('../views/Main/Inventory/Warehouses/MicroserviceWarehouseDetails/MicroserviceWarehouseDetails')
);
const UsersList = lazy(() => import('../views/Main/Users/UsersList/UsersList'));
const UserDetails = lazy(() => import('../views/Main/Users/UserDetails/UserDetails'));
const UsersBulk = lazy(() => import('../views/Main/Users/UsersBulk/UsersBulk'));

const TicketDetails = lazy(() => import('../views/Main/Tickets/TicketDetails/TicketDetails'));
const TicketsList = lazy(() => import('../views/Main/Tickets/TicketsList/TicketsList'));
// const SupportAdminPanel = lazy(() => import('../views/Main/SupportAdminPanel/SupportAdminPanel'));

const ServicesList = lazy(() => import('../views/Main/Services/ServicesList/ServicesList'));
const ContractsList = lazy(() => import('../views/Main/Services/Contracts/ContractsList'));
const ContractDetails = lazy(() => import('../views/Main/Services/Contracts/ContractDetails'));
const ContractLogs = lazy(() => import('../views/Main/Services/Contracts/ContractLogs'));
const ServiceDetails = lazy(() => import('../views/Main/Services/ServiceDetails/ServiceDetails'));
const ServiceOrdersList = lazy(() => import('../views/Main/Services/ServiceOrders/ServiceOrdersList'));
const ServiceOrderDetails = lazy(() => import('../views/Main/Services/ServiceOrders/ServiceOrderDetails'));
const ServiceTypesList = lazy(() => import('../views/Main/ServiceTypes/ServiceTypesList/ServiceTypesList'));
const ServiceTypeDetails = lazy(() => import('../views/Main/ServiceTypes/ServiceTypeDetails/ServiceTypeDetails'));
const FullServiceInstallationReport = lazy(
  () => import('../views/Main/Services/FullServiceInstallationReport/FullServiceInstallationReport')
);
const ServiceCallTechniciansList = lazy(
  () => import('../views/Main/ServiceCalls/Technicians/TechniciansList/TechniciansList')
);
const ChecklistTemplatesPage = lazy(
  () => import('../views/Main/ServiceCalls/ChecklistTemplates/ChecklistTemplatesPage')
);
const ChecklistTemplateDetails = lazy(
  () => import('../views/Main/ServiceCalls/ChecklistTemplates/ChecklistTemplateDetails')
);
const ServiceOrganizationsList = lazy(
  () => import('../views/Main/ServiceCalls/ServiceOrganizations/ServiceOrganizationsList')
);

const PBXsList = lazy(() => import('../views/Main/PBXs/PBXsList/PBXsList'));
const PBXDetails = lazy(() => import('../views/Main/PBXs/PBXDetails/PBXDetails'));
const SyncRouters = lazy(() => import('../views/Main/SyncRouters/SyncRouters'));
const SyncGSATAs = lazy(() => import('../views/Main/SyncGSATAs/SyncGSATAs'));
const DIDDetails = lazy(() => import('../views/Main/DIDs/DIDDetails/DIDDetails'));
const CreateDIDDetails = lazy(() => import('../views/Main/DIDs/DIDDetails/CreateDIDDetails'));
const DIDsBulk = lazy(() => import('../views/Main/DIDs/DIDsBulk/DIDsBulk'));
const DIDsList = lazy(() => import('../views/Main/DIDs/DIDsList/DIDsList'));
const NetsapiensCDRsList = lazy(() => import('../views/Main/CDRs/CDRsList/NetsapiensCDRsList'));
const CSRPCDRsList = lazy(() => import('../views/Main/CDRs/CDRsList/CSRPCDRsList'));
const MegaSwitchCDRsList = lazy(() => import('../views/Main/CDRs/CDRsList/MegaSwitchCDRsList'));
const DialerLogsList = lazy(() => import('../views/Main/DialerLogs/DialerLogsList/DialerLogsList'));
const PortingList = lazy(() => import('../views/Main/Porting/PortingList/PortingList'));
const PortingDetails = lazy(() => import('../views/Main/Porting/PortingDetails/PortingDetails'));
const CreatePortingDetails = lazy(() => import('../views/Main/Porting/PortingDetails/CreatePortingDetails'));
const PortingLogs = lazy(() => import('../views/Main/Porting/PortingLogs/PortingLogs'));
const PRIList = lazy(() => import('../views/Main/PRIs/PRIList/PRIList'));
const PRIsDetails = lazy(() => import('../views/Main/PRIs/PRIsDetails/./PRIDetails'));
const PBXExtensionsList = lazy(() => import('../views/Main/PBXExtensions/PBXExtensionsList/PBXExtensionsList'));
const PBXExtensionDetails = lazy(() => import('../views/Main/PBXExtensions/PBXExtensionDetails/PBXExtensionDetails'));

const EquipmentGroupsList = lazy(() => import('../views/Main/EquipmentGroups/EquipmentGroupsList/EquipmentGroupsList'));
const EquipmentGroupDetails = lazy(
  () => import('../views/Main/EquipmentGroups/EquipmentGroupDetails/EquipmentGroupDetails')
);
const BatteriesList = lazy(() => import('../views/Main/Batteries/BatteriesList/BatteriesList'));
const BatteryDetails = lazy(() => import('../views/Main/Batteries/BatteryDetails/BatteryDetails'));
const BatteriesBulk = lazy(() => import('../views/Main/Batteries/BatteriesBulk/BatteriesBulk'));
const RoutersList = lazy(() => import('../views/Main/Routers/RoutersList/RoutersList'));
const RouterDetails = lazy(() => import('../views/Main/Routers/RouterDetails/RouterDetails'));
const RoutersBulk = lazy(() => import('../views/Main/Routers/RoutersBulk/RoutersBulk'));
const ATAsList = lazy(() => import('../views/Main/ATAs/ATAsList/ATAsList'));
const ATAGrandstreamDetails = lazy(() => import('../views/Main/ATAs/ATADetails/ATAGrandstreamDetails'));
const ATAACSDetails = lazy(() => import('../views/Main/ATAs/ATADetails/ATAACSDetails'));
const PotsCastDetails = lazy(() => import('../views/Main/ATAs/ATADetails/PotsCastDetails'));
const ATAsBulk = lazy(() => import('../views/Main/ATAs/ATAsBulk/ATAsBulk'));
const ATATypesList = lazy(() => import('../views/Main/ATATypes/ATATypesList/ATATypesList'));
const ACSATAProfileDetails = lazy(
  () => import('../views/Main/ACSATAProfiles/ACSATAProfileDetails/ACSATAProfileDetails')
);
const ATATypeDetails = lazy(() => import('../views/Main/ATATypes/ATATypeDetails/ATATypeDetails'));
const ATAOrgTemplatesList = lazy(() => import('../views/Main/ATAOrgTemplates/ATAOrgTemplatesList/ATAOrgTemplatesList'));
const ATAOrgTemplateDetails = lazy(
  () => import('../views/Main/ATAOrgTemplates/ATAOrgTemplateDetails/ATAOrgTemplateDetails')
);
const ATABaseTemplatesList = lazy(
  () => import('../views/Main/ATABaseTemplates/ATABaseTemplatesList/ATABaseTemplatesList')
);
const PRIDevicesList = lazy(() => import('../views/Main/PRIDevices/PRIDevicesList/PRIDevicesList'));
const PRIDeviceDetails = lazy(() => import('../views/Main/PRIDevices/PRIDeviceDetails/PRIDeviceDetails'));
const SmartphonesList = lazy(() => import('../views/Main/Smartphones/SmartphonesList/SmartphonesList'));
const SmartphoneDetails = lazy(() => import('../views/Main/Smartphones/SmartphoneDetails/SmartphoneDetails'));
const ATABaseTemplateDetails = lazy(
  () => import('../views/Main/ATABaseTemplates/ATABaseTemplateDetails/ATABaseTemplateDetails')
);
const DialersList = lazy(() => import('../views/Main/Dialers/DialersList/DialersList'));
const DialerDetails = lazy(() => import('../views/Main/Dialers/DialerDetails/DialerDetails'));
const DialersBulk = lazy(() => import('../views/Main/Dialers/DialersBulk/DialersBulk'));
const EnclosuresList = lazy(() => import('../views/Main/Enclosures/EnclosuresList/EnclosuresList'));
const EnclosureDetails = lazy(() => import('../views/Main/Enclosures/EnclosureDetails/EnclosureDetails'));
const EnclosuresBulk = lazy(() => import('../views/Main/Enclosures/EnclosuresBulk/EnclosuresBulk'));
const PowerCyclesList = lazy(() => import('../views/Main/PowerCycles/PowerCyclesList/PowerCyclesList'));
const PowerCycleDetails = lazy(() => import('../views/Main/PowerCycles/PowerCycleDetails/PowerCycleDetails'));
const PowerCyclesBulk = lazy(() => import('../views/Main/PowerCycles/PowerCyclesBulk/PowerCyclesBulk'));
const InventoryReport = lazy(() => import('../views/Main/Inventory/InventoryReport/InventoryReport'));
const InventoryDevicesList = lazy(() => import('../views/Main/Inventory/Devices/DevicesList/DevicesList'));
const InventoryATADeviceDetails = lazy(
  () => import('../views/Main/Inventory/Devices/ATADeviceDetails/ATADeviceDetails')
);
const InventoryBatteryDeviceDetails = lazy(
  () => import('../views/Main/Inventory/Devices/BatteryDeviceDetails/BatteryDeviceDetails')
);
const InventoryDialerDeviceDetails = lazy(
  () => import('../views/Main/Inventory/Devices/DialerDeviceDetails/DialerDeviceDetails')
);
const InventoryEnclosureDeviceDetails = lazy(
  () => import('../views/Main/Inventory/Devices/EnclosureDeviceDetails/EnclosureDeviceDetails')
);
const InventoryPowerCycleDeviceDetails = lazy(
  () => import('../views/Main/Inventory/Devices/PowerCycleDeviceDetails/PowerCycleDeviceDetails')
);
const InventoryRouterDeviceDetails = lazy(
  () => import('../views/Main/Inventory/Devices/RouterDeviceDetails/RouterDeviceDetails')
);
const InventorySimDeviceDetails = lazy(
  () => import('../views/Main/Inventory/Devices/SimDeviceDetails/SimDeviceDetails')
);
const InventorySmartphoneDeviceDetails = lazy(
  () => import('../views/Main/Inventory/Devices/SmartphoneDeviceDetails/SmartphoneDeviceDetails')
);
const FulfillmentOrdersList = lazy(
  () => import('../views/Main/Inventory/FulfillmentOrders/FulfillmentOrdersList/FulfillmentOrdersList')
);
const NewFulfillmentOrderDetails = lazy(
  () => import('../views/Main/Inventory/FulfillmentOrders/NewFulfillmentOrderDetails/NewFulfillmentOrderDetails')
);
const UpdateFulfillmentOrderDetails = lazy(
  () => import('../views/Main/Inventory/FulfillmentOrders/UpdateFulfillmentOrderDetails/UpdateFulfillmentOrderDetails')
);
const AccessoryBundlesList = lazy(
  () => import('../views/Main/Inventory/AccessoryBundles/AccessoryBundlesList/AccessoryBundlesList')
);
const RMAOrdersList = lazy(() => import('../views/Main/RMAOrders/RMAOrdersList'));
const RMAOrderDetails = lazy(() => import('../views/Main/RMAOrders/RMAOrderDetails'));

const OrderReports = lazy(() => import('../views/Main/OrderReports/OrderReports'));
const DeviceSalesReports = lazy(() => import('../views/Main/DeviceSalesReport/DeviceSalesReport'));

const SIMsList = lazy(() => import('../views/Main/SIMs/SIMsList/SIMsList'));
const SIMDetails = lazy(() => import('../views/Main/SIMs/SIMDetails/SIMDetails'));
const FiberCircuitsList = lazy(() => import('../views/Main/FiberCircuits/FiberCircuitsList/FiberCircuitsList'));
const FiberCircuitDetails = lazy(() => import('../views/Main/FiberCircuits/FiberCircuitDetails/FiberCircuitDetails'));
const StarlinkCircuitsList = lazy(
  () => import('../views/Main/StarlinkCircuits/StarlinkCircuitsList/StarlinkCircuitsList')
);
const StarlinkCircuitDetails = lazy(
  () => import('../views/Main/StarlinkCircuits/StarlinkCircuitDetails/StarlinkCircuitDetails')
);
const DataPlanTypesList = lazy(() => import('../views/Main/DataPlanTypes/DataPlanTypesList/DataPlanTypesList'));
const DataPlanTypeDetails = lazy(() => import('../views/Main/DataPlanTypes/DataPlanTypeDetails/DataPlanTypeDetails'));
const DataPlanDetails = lazy(() => import('../views/Main/DataPlans/DataPlanDetails/DataPlanDetails'));

const Legal = lazy(() => import('../views/Main/Static/legal/Legal'));
const SLA = lazy(() => import('../views/Main/Static/serviceLevelAgreement/ServiceLevelAgreement'));
const SS = lazy(() => import('../views/Main/Static/supportServices/SupportServices'));
const PP = lazy(() => import('../views/Main/Static/privacyPolicy/PrivacyPolicy'));
const AUP = lazy(() => import('../views/Main/Static/acceptableUsePolicy/Aup'));
const Page911 = lazy(() => import('../views/Main/Static/911TermsAndConditions/911TermsAndConditions'));
const Pricing = lazy(() => import('../views/Main/Static/pricing/Pricing'));
const MSA = lazy(() => import('../views/Main/Static/masterServicesAgreement/MasterServicesAgreement'));

const APIDocumentation = lazy(() => import('../views/Main/APIDocumentation/APIDocumentation'));
const ReleaseNotes = lazy(() => import('../views/Main/ReleaseNotes/ReleaseNotes'));
const SingleReleaseNote = lazy(() => import('../views/Main/ReleaseNotes/SingleReleaseNote'));

const CountriesList = lazy(() => import('../views/Main/Countries/CountriesList/CountriesList'));
const CountryDetails = lazy(() => import('../views/Main/Countries/CountryDetails/CountryDetails'));
const CellTowers = lazy(() => import('../views/Main/CellTowers/CellTowers'));
const CellTowerReports = lazy(() => import('../views/Main/CellTowerReports/CellTowerReportsList/CellTowerReportsList'));
const CellTowerReportsDetails = lazy(
  () => import('../views/Main/CellTowerReports/CellTowerReportsDetails/CellTowerReportsDetails')
);
const ULARECentralStationDetails = lazy(
  () => import('../views/Main/ULARECentralStations/ULARECentralStationDetails/ULARECentralStationDetails')
);
const ULARECentralStationsList = lazy(
  () => import('../views/Main/ULARECentralStations/ULARECentralStationsList/ULARECentralStationsList')
);
const ULAREAlarms = lazy(() => import('../views/Main/ULAREAlarms/ULAREAlarmsList/ULAREAlarmsList'));
const AuditLogsList = lazy(() => import('../views/Main/AuditLogs/AuditLogsList/AuditLogsList'));
const AsyncTasksList = lazy(() => import('../views/Main/AsyncTasks/AsyncTasksList/AsyncTasksList'));
const ErrorLogsList = lazy(() => import('../views/Main/ErrorLogs/ErrorLogsList/ErrorLogsList'));
const IssuesTrackerList = lazy(() => import('../views/Main/IssuesTracker/IssuesTrackerList/IssuesTrackerList'));
const IssueTrackerDetails = lazy(() => import('../views/Main/IssuesTracker/IssueTrackerDetails/IssueTrackerDetails'));
const RevioReport = lazy(() => import('../views/Main/AdminTools/RevIoReport/RevIoReport'));
const AccessAndVisibility = lazy(() => import('../views/Main/AccessAndVisibility/AccessAndVisibility'));
const BrandsList = lazy(() => import('../views/Main/Brands/BrandsList/BrandsList'));
const BrandDetails = lazy(() => import('../views/Main/Brands/BrandDetails/BrandDetails'));
const ModelsList = lazy(() => import('../views/Main/Models/ModelList/ModelsList'));
const ModelDetails = lazy(() => import('../views/Main/Models/ModelDetails/ModelDetails'));
const ContactIDMessagesList = lazy(
  () => import('../views/Main/ContactIDMessages/ContactIDMessagesList/ContactIDMessagesList')
);
const CDRsSettings = lazy(() => import('../views/Main/CDRs/CDRsSettings'));
const BucketsList = lazy(() => import('../views/Main/SecureAlarmManager/Buckets/list/BucketsList'));
const BucketDetails = lazy(() => import('../views/Main/SecureAlarmManager/Buckets/detail/BucketDetail'));
const SecureAlarmDidsList = lazy(() => import('../views/Main/SecureAlarmManager/Dids/list/DidsList'));
const SecureAlarmDidsBulk = lazy(() => import('../views/Main/SecureAlarmManager/Dids/bulk/DidsBulk'));
const FulfillmentOrderLogs = lazy(
  () => import('../views/Main/Inventory/FulfillmentOrders/FulfillmentOrderLogs/FulfillmentOrderLogs')
);
const OrderLogs = lazy(() => import('../views/Main/Inventory/Orders/OrderLogs/OrderLogs'));

// Service Calls
const ServiceCallRequestsList = lazy(
  () => import('../views/Main/ServiceCalls/ServiceCallsRequestList/ServiceCallsRequestList')
);
const ServiceCallRequestDetails = lazy(
  () => import('../views/Main/ServiceCalls/ServiceCallRequestDetails/ServiceCallRequestDetails')
);
const ServiceCallReportingDashboard = lazy(
  () => import('../views/Main/ServiceCalls/ServiceCallReportingDashboard/ServiceCallReportingDashboard')
);

// Megaswitch
const MegaswitchInstancesList = lazy(() => import('../views/Main/Megaswitch/InstancesList/InstancesList'));
const MegaswitchInstanceDetails = lazy(() => import('../views/Main/Megaswitch/InstanceDetails/InstanceDetails'));
const MegaswitchDomainsList = lazy(() => import('../views/Main/Megaswitch/DomainsList/DomainsList'));
const MegaswitchCarriersList = lazy(() => import('../views/Main/Megaswitch/CarriersList/CarriersList'));
const MegaswitchDidsList = lazy(() => import('../views/Main/Megaswitch/DidsList/DidsList'));
const MegaswitchUsersList = lazy(() => import('../views/Main/Megaswitch/UsersList/UsersList'));
const MegaswitchOutboundRoutesList = lazy(() => import('../views/Main/Megaswitch/OutboundRouteList/OutboundRouteList'));
const MegaswitchCoresList = lazy(() => import('../views/Main/Megaswitch/CoresList/CoresList'));

const BillProfilesList = lazy(() => import('../views/Main/Billing/BillProfilesList'));
const BillProfileDetails = lazy(() => import('../views/Main/Billing/BillProfileDetails'));
const BillingCredentialsListPage = lazy(() => import('../views/Main/Billing/BillCredentialsList'));

const LeadsList = lazy(() => import('../views/Main/Leads/LeadsList/LeadsList'));
const LeadLogsList = lazy(() => import('../views/Main/LeadLogs/LeadLogsList/LeadLogsList'));

// Permissions
const OrgRolesList = lazy(() => import('../views/Permissions/OrgRolesList/OrgRolesList'));
const OrgRoleDetails = lazy(() => import('../views/Permissions/OrgRoleDetails/OrgRoleDetails'));
const GlobalRolesList = lazy(() => import('../views/Permissions/GlobalRolesList/GlobalRolesList'));
const GlobalRoleDetails = lazy(() => import('../views/Permissions/GlobalRoleDetails/GlobalRoleDetails'));

const NoticesList = lazy(() => import('../views/PotsRetirement/NoticesList/NoticesList'));

type RouteComponent = ComponentType<RouteComponentProps<any>> | ComponentType<any>;

export type RouteType = {
  path: string;
  exact: boolean;
  name: string;
  icon?: string;
  state?: string;
  component?: LazyExoticComponent<RouteComponent>;
  allowedPermissionRoles?: string[];
  requiredGlobalScope?: GlobalScope;
  requiredOrgScope?: OrgScope;
  showIfAnyChildScope?: boolean;
  child?: RouteType[];
  hidden?: boolean;
  isExternal?: boolean;
  pathTo?: string;
  redirect?: boolean;
  beforeEnter?: (route: RouteType & { params: Record<string, string> }) => boolean;
  hasNotification?: (data: NotificationData) => boolean;
};

const ThemeRoutes: Array<RouteType> = [
  {
    path: `${getDashboardPath}`,
    exact: true,
    name: 'Dashboard',
    icon: 'fa fa-bars',
    state: 'dashboard',
    component: NOC,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: `${getNOCPath}`,
        exact: true,
        name: 'NOC',
        state: 'noc',
        icon: 'fa fa-bars',
        component: NOC,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getDashboardOverviewPath}`,
        exact: true,
        name: 'Overview',
        state: 'overview',
        icon: 'fa fa-bars',
        component: Dashboard,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getDashboardMapPath}`,
        exact: true,
        name: 'Map',
        state: 'map',
        icon: 'fa fa-bars',
        component: Map,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getCellTowerReportsPath}`,
        exact: true,
        name: 'Cell Tower Reports',
        state: 'map',
        icon: 'fa fa-bars',
        component: CellTowerReports,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getJotFormOrderPage}`,
        exact: true,
        name: 'Order Inventory',
        state: 'order-jotform',
        icon: 'fa fa-bars',
        component: Order,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 'user', 't3_admin']),
          ...getAllPermissionRolesForUserLevel('reseller'),
        ],
      },
      {
        path: `${getAlertLogsListPath}`,
        exact: true,
        name: 'Alerts',
        state: 'alerts-list',
        icon: 'fa fa-bars',
        component: AlertLogsList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getSalesReportsPath}`,
        exact: true,
        name: 'Sales Reports',
        state: 'sales-reports-list',
        icon: 'fa fa-bars',
        component: SalesReports,
        requiredGlobalScope: 'report_readSale',
      },
    ],
  },
  // ORGANIZATIONS
  {
    path: `${getOrganizationsPath}`,
    exact: true,
    name: 'Organizations',
    icon: 'fa-solid fa-diagram-project',
    state: 'organizations',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: `${getOrganizationListPath}`,
        exact: true,
        name: 'Organizations',
        icon: 'fa-solid fa-diagram-project',
        state: 'organizations-list',
        component: OrganizationsList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getLocationListPath}`,
        exact: true,
        name: 'Locations',
        state: 'locations-list',
        icon: 'fa-solid fa-diagram-project',
        component: LocationsList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: getUserListPath,
        exact: true,
        name: 'Users',
        state: 'users-list',
        icon: 'fa-solid fa-diagram-project',
        component: UsersList,
        requiredOrgScope: 'user_read',
      },
    ],
  },
  {
    path: getUsersBulkDetailsPath,
    exact: true,
    name: 'Users Bulk Import',
    state: 'users-bulk',
    icon: 'fa-solid fa-diagram-project',
    component: UsersBulk,
    hidden: true,
    requiredOrgScope: 'user_bulkCreate',
  },
  // INVENTORY
  {
    path: `${getInventoryPath}`,
    exact: true,
    name: 'Inventory',
    icon: 'fa-solid fa-warehouse',
    state: 'inventory',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: getInventoryMicroserviceWarehousePath,
        exact: true,
        name: 'Warehouses',
        state: 'microservice-warehouse-list',
        icon: 'fa-solid fa-warehouse',
        component: MicroserviceWarehousesList,
        requiredOrgScope: 'inventory_warehouse_read',
      },
      {
        path: `${getInventoryItemsListPath}`,
        exact: true,
        name: 'Devices',
        state: 'inventory-items-list',
        icon: 'fa-solid fa-warehouse',
        component: InventoryDevicesList,
        allowedPermissionRoles: [...devicePermissions.READ],
      },
      {
        path: `${getInventoryOrdersListPath}`,
        exact: true,
        name: 'Fulfillment',
        state: 'inventory-orders-list',
        icon: 'fa-solid fa-warehouse',
        component: FulfillmentOrdersList,
        allowedPermissionRoles: [...fulfillmentOrderPermissions.READ],
      },
      {
        path: `${getInventoryReportPath}`,
        exact: true,
        name: 'Report',
        state: 'inventory-report',
        icon: 'fa-solid fa-warehouse',
        component: InventoryReport,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
          ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin']),
          ...getAllPermissionRolesForUserLevel('customer', ['owner', 'admin']),
        ],
      },
      {
        path: `${getAccessoryBundlesListPath}`,
        exact: true,
        name: 'Accessory Bundles',
        state: 'accessory-bundles-list',
        icon: 'fa-solid fa-box',
        component: AccessoryBundlesList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud', ['admin']),
        ],
      },
      {
        path: `${getNewOrderListPath}`,
        exact: true,
        name: 'Orders',
        state: 'inventory-order-list',
        icon: 'fa fa-bars',
        component: OrdersList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getRMAListPath}`,
        exact: true,
        name: 'RMA Orders',
        state: 'rma-orders-list',
        icon: 'fa-solid fa-box',
        component: RMAOrdersList,
        allowedPermissionRoles: rmaOrderPermissions.READ,
      },
      {
        path: `${getOrderTemplateListPath}`,
        exact: true,
        name: 'Order Templates',
        state: 'inventory-order-templates-list',
        icon: 'fa fa-bars',
        component: OrderTemplatesList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getOrderReportDashboardPath}`,
        exact: true,
        name: 'Order Reports',
        state: 'inventory-order-reports',
        icon: 'fa fa-bars',
        component: OrderReports,
        requiredGlobalScope: 'report_readOrder',
      },
      {
        path: `${getDeviceReportDashboardPath}`,
        exact: true,
        name: 'POTSCAST Sales Tracker',
        state: 'inventory-device-sales-reports',
        icon: 'fa fa-bars',
        component: DeviceSalesReports,
        requiredGlobalScope: 'report_readPotscastSale',
      },
    ],
  },
  // SUPPORT
  {
    path: `${getSupportPath}`,
    exact: true,
    name: 'Support',
    icon: 'fa fa-headset',
    state: 'support',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: `${getTicketListPath}`,
        exact: true,
        name: 'Tickets',
        state: 'tickets-list',
        icon: 'fa fa-headset',
        component: TicketsList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      // {
      //   path: `${getSupportAdminPanelPath}`,
      //   exact: true,
      //   name: 'Support Admin Panel',
      //   state: 'support-admin-panel',
      //   icon: 'fa fa-headset',
      //   component: SupportAdminPanel,
      //   allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
      // },
    ],
  },

  // SERVICE CALLS
  {
    path: `${getServiceCallsRequestListPath}`,
    exact: true,
    name: 'Service Calls',
    icon: 'fa fa-phone-square',
    state: 'service-calls',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      PERMISSIONROLECONSTANTS.field_services,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: getServiceCallsRequestListPath,
        exact: true,
        name: 'Service Requests',
        icon: 'fas fa-tools',
        state: 'service-call-requests-list',
        component: ServiceCallRequestsList,
        requiredOrgScope: 'serviceCall_read',
      },
      {
        path: getServiceCallReportPath,
        exact: true,
        name: 'Service Call Report',
        icon: 'fas fa-chart-bar',
        state: 'service-call-reporting',
        component: ServiceCallReportingDashboard,
        requiredOrgScope: 'serviceCall_report',
      },
      {
        path: getTechniciansListPath,
        exact: true,
        name: 'Technicians',
        icon: 'fas fa-tools',
        state: 'technicians-list',
        component: ServiceCallTechniciansList,
        requiredGlobalScope: 'serviceCall_technician_read',
      },
      {
        path: getServiceOrganizationsListPath,
        exact: true,
        name: 'Service Organizations',
        icon: 'fas fa-building',
        state: 'service-organizations-list',
        component: ServiceOrganizationsList,
        requiredGlobalScope: 'serviceCall_serviceOrganization_read',
      },
      {
        path: getChecklistTemplatesPath,
        exact: true,
        name: 'Checklist Templates',
        icon: 'fas fa-list-check',
        state: 'service-call-checklist-templates',
        component: ChecklistTemplatesPage,
        requiredGlobalScope: 'serviceCall_checklistTemplate_read',
      },
      {
        path: getFullServiceInstallationReportPath,
        exact: true,
        name: 'Full Service Installation Report',
        state: 'full-service-installation-report',
        icon: 'fas fa-file-alt',
        component: FullServiceInstallationReport,
        requiredGlobalScope: 'report_readFullServiceInstallation',
      },
    ],
  },
  // SERVICES
  {
    path: `${getServicesPath}`,
    exact: true,
    name: 'Services',
    state: 'services',
    icon: 'fas fa-tools',
    component: ServicesList,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: `${getServiceListPath}`,
        exact: true,
        name: 'Services Info',
        icon: 'fas fa-tools',
        state: 'services-list',
        component: ServicesList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getContractsListPath}`,
        exact: true,
        name: 'Contract Services',
        icon: 'fas fa-tools',
        state: 'contracts-list',
        component: ContractsList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          // ...getAllPermissionRolesForUserLevel('reseller'),
          // ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getServiceOrdersListPath}`,
        exact: true,
        name: 'Service Orders',
        state: 'service-orders-list',
        icon: 'fas fa-file-contract',
        component: ServiceOrdersList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          // ...getAllPermissionRolesForUserLevel('reseller'),
          // ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getServiceTypeListPath}`,
        exact: true,
        name: 'Service Types',
        state: 'services-types-list',
        icon: 'fas fa-tools',
        component: ServiceTypesList,
        allowedPermissionRoles: serviceTypePermissions.READ,
      },

      // {
      //   path: `${getRevIoFieldIdsListPath}`,
      //   exact: true,
      //   name: 'Rev.io Field IDs',
      //   icon: 'fas fa-tools',
      //   component: RevIoFieldIDsList,
      //   allowedPermissionRoles: [...RevIoFieldIdPermissions.READ],
      // },
    ],
  },
  // TELCO
  {
    path: getTelcoPath,
    exact: true,
    name: 'Telco',
    icon: 'fa fa-cloud',
    state: 'telco',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: getPBXListPath,
        exact: true,
        name: 'PBXs',
        state: 'pbxs-list',
        icon: 'fa fa-cloud',
        component: PBXsList,
        requiredOrgScope: 'pbx_read',
      },
      {
        path: getPBXExtensionsListPath,
        exact: true,
        name: 'PBX Extensions',
        state: 'pbx-extensions-list',
        icon: 'fa fa-cloud',
        component: PBXExtensionsList,
        requiredOrgScope: 'pbx_extension_read',
      },
      {
        path: `${getDIDListPath}`,
        exact: true,
        name: 'DIDs',
        state: 'dids-list',
        icon: 'fa fa-cloud',
        component: DIDsList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },

      {
        path: `${getCdrsListPath}`,
        exact: true,
        name: 'CDRs',
        icon: 'fa fa-cloud',
        state: 'cdrs-list',
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
        child: [
          {
            path: `${getCSRPCdrsListPath}`,
            exact: true,
            name: 'CSRP',
            icon: 'fa fa-cloud',
            state: 'cdrs-list-csrp',
            component: CSRPCDRsList,
            allowedPermissionRoles: CDRPermissions.READ,
          },
          {
            path: `${getNetsapiensCdrsListPath}`,
            exact: true,
            name: 'PBX (Netsapiens)',
            icon: 'fa fa-cloud',
            state: 'cdrs-list-netsapiens',
            component: NetsapiensCDRsList,
            allowedPermissionRoles: CDRPermissions.READ,
          },
          {
            path: `${getMegaSwitchCdrsListPath}`,
            exact: true,
            name: 'PBX (MegaSwitch)',
            icon: 'fa fa-cloud',
            state: 'cdrs-list-megaswitch',
            component: MegaSwitchCDRsList,
            allowedPermissionRoles: CDRPermissions.READ,
          },
          {
            path: `${getCdrsSettingsPath}`,
            exact: true,
            name: 'Settings',
            icon: 'fa fa-cloud',
            state: 'cdrs-settings',
            component: CDRsSettings,
            allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
          },
        ],
      },
      {
        path: getDialerLogsListPath,
        exact: true,
        name: 'Dialer Logs',
        state: 'dialer-logs-list',
        icon: 'fa fa-briefcase',
        component: DialerLogsList,
        requiredOrgScope: 'equipment_dialer_log_read',
      },
      {
        path: `${getContactIDMessagesPath}`,
        exact: true,
        name: 'Alarm Signals',
        state: 'contact-id-messages-list',
        icon: 'fa fa-sitemap',
        component: ContactIDMessagesList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getPortingListPath}`,
        exact: true,
        name: 'Porting',
        state: 'porting-list',
        icon: 'fa fa-briefcase',
        component: PortingList,
        requiredOrgScope: 'port_request_read',
      },
      {
        path: `${getPRIListPath}`,
        exact: true,
        name: 'PRI Trunks',
        state: 'pri-list',
        icon: 'fa fa-briefcase',
        component: PRIList,
        allowedPermissionRoles: priPermissions.READ,
      },
    ],
  },
  // ULARE
  {
    path: `${getULAREPath}`,
    exact: true,
    name: 'ULARE',
    icon: 'fa-solid fa-chess-rook',
    state: 'ulare',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: `${getULARECentralStationsListPath}`,
        exact: true,
        name: 'Central Stations',
        icon: 'fa fa-sitemap',
        state: 'ulare-central-stations',
        component: ULARECentralStationsList,
        allowedPermissionRoles: ulareCentralStationPermissions.READ,
      },
      {
        path: `${getULAREAlarmsListPath}`,
        exact: true,
        name: 'Alarms',
        icon: 'fa fa-sitemap',
        state: 'ulare-alarms',
        component: ULAREAlarms,
      },
    ],
  },
  // MEGASWITCH
  {
    path: `${getMegaswitchPath}`,
    exact: true,
    name: 'Megaswitch',
    icon: 'fa fa-server',
    state: 'megaswitch',
    showIfAnyChildScope: true,
    child: [
      {
        path: `${getMegaswitchInstancesListPath}`,
        exact: true,
        name: 'Instances',
        state: 'megaswitch-instances-list',
        icon: 'fa fa-server',
        component: MegaswitchInstancesList,
        requiredGlobalScope: 'megaswitch_instance_read',
      },
      {
        path: `${getMegaswitchDomainsListPath}`,
        exact: true,
        name: 'Domains',
        state: 'megaswitch-domains-list',
        icon: 'fa fa-server',
        component: MegaswitchDomainsList,
        requiredOrgScope: 'megaswitch_domain_read',
      },
      {
        path: `${getMegaswitchCarriersListPath}`,
        exact: true,
        name: 'Carriers',
        state: 'megaswitch-carriers-list',
        icon: 'fa fa-server',
        component: MegaswitchCarriersList,
        requiredOrgScope: 'megaswitch_carrier_read',
      },
      {
        path: `${getMegaswitchDidsListPath}`,
        exact: true,
        name: 'Megaswitch DIDs',
        state: 'megaswitch-dids-list',
        icon: 'fa fa-phone',
        component: MegaswitchDidsList,
        requiredOrgScope: 'megaswitch_did_read',
      },
      {
        path: `${getMegaswitchUsersListPath}`,
        exact: true,
        name: 'Megaswitch Users',
        state: 'megaswitch-users-list',
        icon: 'fa fa-users',
        component: MegaswitchUsersList,
        requiredOrgScope: 'megaswitch_user_read',
      },
      {
        path: `${getMegaswitchOutboundRoutesListPath}`,
        exact: true,
        name: 'Outbound Routes',
        state: 'megaswitch-outbound-routes-list',
        icon: 'fa fa-route',
        component: MegaswitchOutboundRoutesList,
        requiredOrgScope: 'megaswitch_outboundRoute_read',
      },
      {
        path: `${getMegaswitchCoresListPath}`,
        exact: true,
        name: 'Cores',
        state: 'megaswitch-cores-list',
        icon: 'fa fa-server',
        component: MegaswitchCoresList,
        requiredOrgScope: 'megaswitch_core_read',
      },
    ],
  },
  // EQUIPMENT
  {
    path: `${getEquipmentsPath}`,
    exact: true,
    name: 'Equipment',
    icon: 'fa fa-briefcase',
    state: 'equipment',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: getEquipmentGroupListPath,
        exact: true,
        name: 'Groups',
        state: 'equipment-groups-list',
        icon: 'fa fa-briefcase',
        component: EquipmentGroupsList,
        requiredOrgScope: 'equipment_group_read',
      },
      {
        path: getBatteryListPath,
        exact: true,
        name: 'Batteries',
        state: 'batteries-list',
        icon: 'fa fa-briefcase',
        component: BatteriesList,
        requiredOrgScope: 'equipment_battery_read',
      },
      {
        path: getRouterListPath,
        exact: true,
        name: 'Routers',
        state: 'routers-list',
        icon: 'fa fa-briefcase',
        component: RoutersList,
        requiredOrgScope: 'equipment_router_read',
      },
      {
        path: `${getATAListPath}`,
        exact: true,
        name: 'ATAs',
        state: 'atas-list',
        icon: 'fa fa-briefcase',
        component: ATAsList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getATATypeListPath}`,
        exact: true,
        name: 'ATA Types',
        state: 'ata-types-list',
        icon: 'fa fa-briefcase',
        component: ATATypesList,
        allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
      },
      {
        path: `${getATAOrgTemplatesListPath}`,
        exact: true,
        name: 'ATA Org Templates',
        state: 'ata-org-templates-list',
        icon: 'fa fa-briefcase',
        component: ATAOrgTemplatesList,
        allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
      },
      {
        path: `${getATABaseTemplatesListPath}`,
        exact: true,
        name: 'ATA Base Templates',
        state: 'ata-base-templates-list',
        icon: 'fa fa-briefcase',
        component: ATABaseTemplatesList,
        requiredGlobalScope: 'equipment_ata_baseTemplate_read',
      },
      {
        path: `${getPRIDevicesListPath}`,
        exact: true,
        name: 'PRI Devices',
        state: 'pri-devices-list',
        icon: 'fa fa-briefcase',
        component: PRIDevicesList,
        requiredOrgScope: 'equipment_pri_device_read',
      },
      {
        path: `${getSmartphonesListPath}`,
        exact: true,
        name: 'Smartphones',
        state: 'smartphones-list',
        icon: 'fa fa-briefcase',
        component: SmartphonesList,
        requiredOrgScope: 'equipment_smartphone_read',
      },
      {
        path: getDialersListPath,
        exact: true,
        name: 'Dialers',
        state: 'dialers-list',
        icon: 'fa fa-briefcase',
        component: DialersList,
        requiredOrgScope: 'equipment_dialer_read',
      },
      {
        path: getEnclosuresListPath,
        exact: true,
        name: 'Enclosures',
        state: 'enclosures-list',
        icon: 'fa fa-briefcase',
        component: EnclosuresList,
        requiredOrgScope: 'equipment_enclosure_read',
      },
      {
        path: getPowerCyclesListPath,
        exact: true,
        name: 'PowerCycle',
        state: 'powercycle-list',
        icon: 'fa fa-briefcase',
        component: PowerCyclesList,
        requiredOrgScope: 'equipment_powerCycle_read',
      },
    ],
  },
  // CONNECTIVITY
  {
    path: `${getConnectivityPath}`,
    exact: true,
    name: 'Connectivity',
    icon: 'fa fa-globe',
    state: 'connectivity',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: getCellularListPath,
        exact: true,
        name: 'Cellular',
        icon: 'fa fa-globe',
        state: 'connectivity-cellular',
        showIfAnyChildScope: true,
        child: [
          {
            path: getSimsListPath,
            exact: true,
            name: 'SIMs',
            state: 'sims-list',
            icon: 'fa fa-gavel',
            component: SIMsList,
            requiredOrgScope: 'sim_read',
          },
        ],
      },
      {
        path: getWirelineListPath,
        exact: true,
        name: 'Wireline',
        icon: 'fa fa-globe',
        state: 'connectivity-wireline',
        requiredOrgScope: 'fiberCircuit_read',
        child: [
          {
            path: getFiberCircuitsListPath,
            exact: true,
            name: 'Fiber Circuits',
            state: 'fiber-circuits-list',
            icon: 'fa fa-gavel',
            component: FiberCircuitsList,
            requiredOrgScope: 'fiberCircuit_read',
          },
        ],
      },
      {
        path: getLEOListPath,
        exact: true,
        name: 'LEO',
        icon: 'fa fa-globe',
        state: 'connectivity-leo',
        requiredOrgScope: 'starlinkCircuit_read',
        child: [
          {
            path: getStarlinksListPath,
            exact: true,
            name: 'Starlink',
            state: 'starlink-list',
            icon: 'fa fa-gavel',
            component: StarlinkCircuitsList,
            requiredOrgScope: 'starlinkCircuit_read',
          },
        ],
      },
    ],
  },
  // LEGAL
  {
    path: `${getLegalPage}`,
    exact: true,
    name: 'Legal',
    icon: 'fa fa-gavel',
    state: 'legal',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
    ],
    child: [
      {
        path: `${getMsaPage}`,
        exact: true,
        name: 'Master Services Agreement',
        state: 'master-services-agreement',
        icon: 'fa fa-gavel',
        component: MSA,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
        ],
      },
      {
        path: `${get911TermsAndConditionsPage}`,
        exact: true,
        name: '911 Terms & Conditions',
        state: '911-terms-&-conditions',
        icon: 'fa fa-gavel',
        component: Page911,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
        ],
      },
      {
        path: `${getSupportServicesPage}`,
        exact: true,
        name: 'Support Service',
        state: 'support-service',
        icon: 'fa fa-gavel',
        component: SS,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
        ],
      },
      {
        path: `${getAcceptableUsePolicyPage}`,
        exact: true,
        name: 'Acceptable Use Policy',
        state: 'acceptable-use-policy',
        icon: 'fa fa-gavel',
        component: AUP,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
        ],
      },
      {
        path: `${getPrivacyPolicyPage}`,
        exact: true,
        name: 'Privacy Policy',
        state: 'privacy-policy',
        icon: 'fa fa-gavel',
        component: PP,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
        ],
      },
    ],
  },
  // DOCs
  {
    path: `${getDocsPath}`,
    exact: true,
    name: 'Docs',
    icon: 'fa-sharp fa-solid fa-circle-info',
    state: 'docs',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: `${getPotsPortalPath}`,
        exact: true,
        isExternal: true,
        name: 'Need Help?',
        state: 'need-help',
        icon: 'fa-sharp fa-solid fa-circle-info',
        component: APIDocumentation,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getCustomerApiDocsPath}`,
        exact: true,
        name: 'API Documentation',
        state: 'api-documentation',
        icon: 'fa-sharp fa-solid fa-circle-info',
        component: APIDocumentation,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
      },
      {
        path: `${getReleaseNotesPath}`,
        exact: true,
        name: 'Release Notes',
        state: 'release-notes',
        icon: 'fa-sharp fa-solid fa-circle-info',
        component: ReleaseNotes,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud'),
          ...getAllPermissionRolesForUserLevel('reseller'),
          ...getAllPermissionRolesForUserLevel('customer'),
        ],
        hasNotification: data => data.hasUnreadReleaseNotes,
      },
    ],
  },
  // SECURE ALARM MANAGER
  {
    path: `${getSecureALARMManager}`,
    exact: true,
    name: 'Secure Alarm',
    state: 'secure-alarm',
    icon: 'fa-solid fa-business-time',
    allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
    child: [
      {
        path: `${getSecureALARMManagerBuckets}`,
        exact: true,
        name: 'Secure Alarm Buckets',
        state: 'buckets-list',
        component: BucketsList,
        allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
      },
      {
        path: `${getSecureALARMManagerDids}`,
        exact: true,
        name: 'Secure Alarm DIDs',
        state: 'secure-alarm-dids-list',
        component: SecureAlarmDidsList,
        allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
      },
    ],
  },
  // PERMISSIONS
  {
    path: getPermissionsPath,
    exact: true,
    name: 'Permissions',
    icon: 'fa fa-lock',
    allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
    child: [
      {
        path: getOrgRolesListPath,
        exact: true,
        name: 'Organization Roles',
        component: OrgRolesList,
        allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
      },
      {
        path: getGlobalRolesListPath,
        exact: true,
        name: 'Global Roles',
        component: GlobalRolesList,
        allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
      },
    ],
  },
  // OTHER
  {
    path: `${getOtherPath}`,
    exact: true,
    name: 'Other',
    icon: 'fa fa-sitemap',
    state: 'other',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    child: [
      {
        path: getCountriesListPath,
        exact: true,
        name: 'Countries',
        icon: 'fa fa-sitemap',
        state: 'countries-list',
        component: CountriesList,
        requiredGlobalScope: 'country_read',
      },
      {
        path: `${getDataPlanTypeListPath}`,
        exact: true,
        name: 'Data Plan Types',
        state: 'data-plan-types-list',
        icon: 'fa fa-briefcase',
        component: DataPlanTypesList,
        allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
      },
      {
        path: `${getCellTowersListPath}`,
        exact: true,
        name: 'Cell Towers',
        icon: 'fa fa-sitemap',
        state: 'cell-towers',
        component: CellTowers,
        allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
      },
      {
        path: `${getAuditLogsListPath}`,
        exact: true,
        name: 'Audit Logs',
        state: 'audit-logs-list',
        icon: 'fa fa-sitemap',
        component: AuditLogsList,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
        ],
      },
      {
        path: getAsyncTasksListPath,
        exact: true,
        name: 'Async Tasks',
        state: 'async-tasks-list',
        icon: 'fa fa-sitemap',
        component: AsyncTasksList,
        requiredGlobalScope: 'asyncTask_read',
      },
      {
        path: getErrorLogsListPath,
        exact: true,
        name: 'Error Logs',
        state: 'error-logs-list',
        icon: 'fa fa-sitemap',
        component: ErrorLogsList,
        requiredGlobalScope: 'errorLog_read',
      },
      {
        path: getIssueTrackerListPath,
        exact: true,
        name: 'Issues Tracker',
        icon: 'fa fa-sitemap',
        state: 'issues-tracker-list',
        component: IssuesTrackerList,
        requiredGlobalScope: 'issueTracker_read',
      },
      {
        path: `${getRevioVerificationReportsPath}`,
        exact: true,
        name: 'Rev.io Reports',
        icon: 'fa fa-sitemap',
        state: 'rev-io-reports-list',
        component: RevioReport,
        requiredGlobalScope: 'report_readRevio',
      },
      {
        path: getModelsListPath,
        exact: true,
        name: 'Models',
        state: 'models',
        icon: 'fa fa-sitemap',
        component: ModelsList,
        requiredGlobalScope: 'model_read',
      },
      {
        path: getBrandsListPath,
        exact: true,
        name: 'Brands',
        state: 'brands',
        icon: 'fa fa-sitemap',
        component: BrandsList,
        requiredGlobalScope: 'brand_read',
      },
      {
        path: getBillProfilesListPath,
        exact: true,
        name: 'Bill Profiles',
        state: 'bill-profiles-list',
        icon: 'fa fa-credit-card',
        component: BillProfilesList,
        requiredGlobalScope: 'bill_profile_read',
      },
      {
        path: getBillingCredentialsListPath,
        exact: true,
        name: 'Billing Credentials',
        state: 'billing-credentials-list',
        icon: 'fa fa-key',
        component: BillingCredentialsListPage,
        requiredGlobalScope: 'bill_credential_read',
      },
      {
        path: getLeadsListPath,
        exact: true,
        name: 'Leads',
        state: 'leads-list',
        icon: 'fa fa-sitemap',
        component: LeadsList,
        requiredGlobalScope: 'lead_read',
      },
      {
        path: getLeadLogsListPath,
        exact: true,
        name: 'Lead Logs',
        state: 'lead-logs',
        icon: 'fa fa-sitemap',
        component: LeadLogsList,
        requiredGlobalScope: 'lead_log_read',
      },
      {
        path: getPotsRetirementNoticesListPath,
        exact: true,
        name: 'POTS Retirement Notices',
        state: 'pots-retirement-notices-list',
        component: NoticesList,
        requiredGlobalScope: 'telcoSunset_notice_read',
      },
    ],
  },
  // ACCESSIBILITY
  {
    path: `${getAccessAndVisibilityPath}`,
    exact: true,
    name: 'Accessibility',
    icon: 'fa fa-shield-alt',
    state: 'accessibility',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
      ...getAllPermissionRolesForUserLevel('reseller', ['admin']),
    ],
    child: [
      {
        path: `${getAccessAndVisibilityPath}`,
        exact: true,
        name: 'Visibility Settings',
        icon: 'fa fa-eye',
        state: 'visibility-settings',
        component: AccessAndVisibility,
        allowedPermissionRoles: [
          PERMISSIONROLECONSTANTS.superadmin,
          ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
          ...getAllPermissionRolesForUserLevel('reseller', ['admin']),
        ],
      },
    ],
  },
  {
    path: getModelDetailsPath,
    exact: true,
    name: 'Model Details',
    component: ModelDetails,
    requiredGlobalScope: 'model_read',
    hidden: true,
  },
  {
    path: getBrandDetailsPath,
    exact: true,
    name: 'Brand Details',
    component: BrandDetails,
    requiredGlobalScope: 'brand_read',
    hidden: true,
  },
  {
    path: `${getCellTowerReportDetailsPath}`,
    exact: true,
    name: 'Cell Tower Report Details',
    component: CellTowerReportsDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  // OTHER
  // {
  //   collapse: true,
  //   path: `${getServiceCallPath}`,
  //   exact: true,
  //   name: 'Service Calls',
  //   icon: 'fa-solid fa-server',
  //   state: 'service-call',
  //   allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
  //   child: [
  //     {
  //       path: `${getServiceCallRequestsListPath}`,
  //       exact: true,
  //       name: 'Service Requests',
  //       icon: 'fa fa-sitemap',
  //       state: 'service-call-requests-list',
  //       component: ServiceCallRequestsList,
  //       allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
  //     },
  //     {
  //       path: `${getServiceCallProvidersListPath}`,
  //       exact: true,
  //       name: 'Service Providers',
  //       icon: 'fa fa-sitemap',
  //       state: 'service-call-providers-list',
  //       component: ServiceCallProvidersList,
  //       allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
  //     },
  //     {
  //       path: `${getServiceCallTechniciansListPath}`,
  //       exact: true,
  //       name: 'Service Technicians',
  //       icon: 'fa fa-sitemap',
  //       state: 'service-call-technicians-list',
  //       component: ServiceCallTechniciansList,
  //       allowedPermissionRoles: serviceCallTechnicianPermissions.READ,
  //     },
  //     {
  //       path: `${getServiceCallSiteSurveysListPath}`,
  //       exact: true,
  //       name: 'Site Survey',
  //       icon: 'fa fa-sitemap',
  //       state: 'service-call-site-surveys',
  //       component: SiteSurveysList,
  //       allowedPermissionRoles: serviceCallProviderPermissions.READ,
  //     },
  //   ],
  // },
  {
    path: `${getSingleReleaseNotesPath}`,
    exact: true,
    name: 'Release Note Details',
    component: SingleReleaseNote,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
  },
  // DASHBOARD
  {
    path: `${getOrdersDetailsPath}`,
    exact: true,
    name: 'Order Details',
    component: OrderDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getRMADetailsPath}`,
    exact: true,
    name: 'RMA Order',
    component: RMAOrderDetails,
    allowedPermissionRoles: rmaOrderPermissions.READ,
    hidden: true,
  },
  {
    path: `${getNewOrderDetailsPath}`,
    exact: true,
    name: 'Order Details',
    component: NewOrderDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getOrderTemplateDetailsPath}`,
    exact: true,
    name: 'Order Template Details',
    component: OrderTemplateDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getNewOrderDetailsPath}`,
    exact: true,
    name: 'Order Details',
    component: NewOrderDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  // ORGANIZATIONS
  {
    path: `${getOrganizationDetailsPath}`,
    exact: true,
    name: 'Organization Details',
    component: OrganizationDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getLocationsBulkDetailsPath}`,
    exact: true,
    name: 'Locations Bulk',
    component: LocationsBulk,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getLocationDetailsPath}`,
    exact: true,
    name: 'Location Details',
    component: LocationDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: getInventoryMicroserviceWarehouseDetailsPath,
    exact: true,
    name: 'Warehouse Details',
    component: MicroserviceWarehouseDetails,
    hidden: true,
  },
  {
    path: `${getInventoryCreateOrderDetailsPath}`,
    exact: true,
    name: 'Fulfillment Details',
    component: NewFulfillmentOrderDetails,
    hidden: true,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
      ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin']),
    ],
  },
  {
    path: `${getInventoryModifyOrderDetailsPath}`,
    exact: true,
    name: 'Fulfillment Details',
    component: UpdateFulfillmentOrderDetails,
    hidden: true,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
      ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin']),
    ],
  },
  {
    path: getUserDetailsPath,
    exact: true,
    name: 'User Details',
    component: UserDetails,
    hidden: true,
  },
  // SUPPORT
  {
    path: `${getTicketDetailsPath}`,
    exact: true,
    name: 'Ticket Details',
    component: TicketDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  // SERVICES
  {
    path: `${getServiceDetailsPath}`,
    exact: true,
    name: 'Service Details',
    component: ServiceDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getContractDetailsPath}`,
    exact: true,
    name: 'Contract Service Details',
    component: ContractDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      // ...getAllPermissionRolesForUserLevel('reseller'),
      // ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getContractLogsPath}`,
    exact: true,
    name: 'Contract Service Logs',
    component: ContractLogs,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      // ...getAllPermissionRolesForUserLevel('reseller'),
      // ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getServiceOrderDetailsPath}`,
    exact: true,
    name: 'Service Order Details',
    component: ServiceOrderDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      // ...getAllPermissionRolesForUserLevel('reseller'),
      // ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
    icon: undefined,
    state: undefined,
  },
  {
    path: `${getServiceTypeDetailsPath}`,
    exact: true,
    name: 'Service Type Details',
    component: ServiceTypeDetails,
    allowedPermissionRoles: serviceTypePermissions.READ,
    hidden: true,
  },
  // SERVICE CALLS
  {
    path: `${getServiceCallsRequestDetailsPath}`,
    exact: true,
    name: 'Service Call Request Details',
    component: ServiceCallRequestDetails,
    requiredOrgScope: 'serviceCall_read',
    hidden: true,
  },
  {
    path: getChecklistTemplateDetailsPath,
    exact: true,
    name: 'Checklist Template Details',
    component: ChecklistTemplateDetails,
    requiredGlobalScope: 'serviceCall_checklistTemplate_read',
    hidden: true,
  },

  // {
  //   path: `${getRevIoFieldIdDetailsPath}`,
  //   exact: true,
  //   name: 'Rev.io Field ID Details',
  //   component: RevIoFieldIDDetails,
  //   allowedPermissionRoles: [...RevIoFieldIdPermissions.READ],
  //   hidden: true,
  // },
  //  TELCO
  {
    path: getPBXDetailsPath,
    exact: true,
    name: 'PBX Details',
    component: PBXDetails,
    hidden: true,
  },
  // {
  //   path: `${getPbxExtensionDetailsPath}`,
  //   exact: true,
  //   name: 'PBX Extension Details',
  //   component: PBXExtensionDetails,
  //   allowedPermissionRoles: [
  //     PERMISSIONROLECONSTANTS.superadmin,
  //     ...getAllPermissionRolesForUserLevel('telcloud'),
  //     ...getAllPermissionRolesForUserLevel('reseller'),
  //     ...getAllPermissionRolesForUserLevel('customer'),
  //   ],
  //   hidden: true,
  // },
  {
    path: `${getDIDBulkDetailsPath}`,
    exact: true,
    name: 'DIDs Bulk',
    component: DIDsBulk,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 'user']),
      ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin', 'user']),
    ],
    hidden: true,
  },
  {
    path: `${getCreateDIDDetailsPath}`,
    exact: true,
    name: 'Create DID',
    component: CreateDIDDetails,
    allowedPermissionRoles: didPermissions.CREATE,
    hidden: true,
  },
  {
    path: `${getDIDDetailsPath}`,
    exact: true,
    name: 'DID Details',
    component: DIDDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: getCreatePortingDetailsPath,
    exact: true,
    name: 'Create Port Request',
    component: CreatePortingDetails,
    requiredOrgScope: 'port_request_read',
    hidden: true,
  },
  {
    path: getPortingDetailsPath,
    exact: true,
    name: 'Port Request Details',
    component: PortingDetails,
    requiredOrgScope: 'port_request_read',
    hidden: true,
  },
  {
    path: `${getPRIDetailsPath}`,
    exact: true,
    name: 'PRI Trunk Details',
    component: PRIsDetails,
    allowedPermissionRoles: priPermissions.READ,
    hidden: true,
  },
  {
    path: `${getPBXExtensionDetailsPath}`,
    exact: true,
    name: 'PBX Extension Details',
    component: PBXExtensionDetails,
    hidden: true,
    requiredOrgScope: 'pbx_extension_read',
  },
  // EQUIPMENT
  {
    path: getEquipmentGroupDetailsPath,
    exact: true,
    name: 'Equipment Group Details',
    component: EquipmentGroupDetails,
    hidden: true,
  },
  {
    path: getBatteriesBulkDetailsPath,
    exact: true,
    name: 'Batteries Bulk',
    component: BatteriesBulk,
    requiredOrgScope: 'equipment_battery_bulkCreate',
    hidden: true,
  },
  {
    path: getBatteryDetailsPath,
    exact: true,
    name: 'Battery Details',
    component: BatteryDetails,
    hidden: true,
  },
  {
    path: getRoutersBulkDetailsPath,
    exact: true,
    name: 'Routers Bulk',
    component: RoutersBulk,
    requiredOrgScope: 'equipment_router_bulkCreate',
    hidden: true,
  },
  {
    path: getSyncRoutersListPath,
    exact: true,
    name: 'Sync Routers',
    component: SyncRouters,
    requiredOrgScope: 'equipment_router_sync_read',
    hidden: true,
  },
  {
    path: getSyncGSATAsListPath,
    exact: true,
    name: 'Sync GS ATAs',
    component: SyncGSATAs,
    allowedPermissionRoles: ataPermissions.CREATE,
    hidden: true,
  },
  {
    path: getRouterDetailsPath,
    exact: true,
    name: 'Router Details',
    component: RouterDetails,
    hidden: true,
  },
  {
    path: `${getATABulkDetailsPath}`,
    exact: true,
    name: 'ATAs Bulk',
    component: ATAsBulk,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
    ],
    hidden: true,
  },
  {
    path: `${getATAGrandstreamDetailsPath}`,
    exact: true,
    name: 'ATA Grandstream Details',
    component: ATAGrandstreamDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getInventoryATAItemDetailsPath}`,
    exact: true,
    name: 'Inventory ATA Details',
    component: InventoryATADeviceDetails,
    allowedPermissionRoles: [...devicePermissions.READ],
    hidden: true,
  },
  {
    path: `${getInventoryBatteryItemDetailsPath}`,
    exact: true,
    name: 'Inventory Battery Details',
    component: InventoryBatteryDeviceDetails,
    allowedPermissionRoles: [...devicePermissions.READ],
    hidden: true,
  },
  {
    path: `${getInventoryDialerItemDetailsPath}`,
    exact: true,
    name: 'Inventory Dialer Details',
    component: InventoryDialerDeviceDetails,
    allowedPermissionRoles: [...devicePermissions.READ],
    hidden: true,
  },
  {
    path: `${getInventoryEnclosureItemDetailsPath}`,
    exact: true,
    name: 'Inventory Enclosure Details',
    component: InventoryEnclosureDeviceDetails,
    allowedPermissionRoles: [...devicePermissions.READ],
    hidden: true,
  },
  {
    path: `${getInventoryPowerCycleItemDetailsPath}`,
    exact: true,
    name: 'Inventory PowerCycle Details',
    component: InventoryPowerCycleDeviceDetails,
    allowedPermissionRoles: [...devicePermissions.READ],
    hidden: true,
  },
  {
    path: `${getInventoryRouterItemDetailsPath}`,
    exact: true,
    name: 'Inventory Router Details',
    component: InventoryRouterDeviceDetails,
    allowedPermissionRoles: [...devicePermissions.READ],
    hidden: true,
  },
  {
    path: `${getInventorySimItemDetailsPath}`,
    exact: true,
    name: 'Inventory Sim Details',
    component: InventorySimDeviceDetails,
    allowedPermissionRoles: [...devicePermissions.READ],
    hidden: true,
  },
  {
    path: `${getInventorySmartphoneItemDetailsPath}`,
    exact: true,
    name: 'Inventory Smartphone Details',
    component: InventorySmartphoneDeviceDetails,
    allowedPermissionRoles: [...devicePermissions.READ],
    hidden: true,
  },
  {
    path: `${getATAACSDetailsPath}`,
    exact: true,
    name: 'ATA Details',
    component: ATAACSDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getPotscastDetailsPath}`,
    exact: true,
    name: 'Potscast Details',
    component: PotsCastDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getATATypeDetailsPath}`,
    exact: true,
    name: 'ATA Type Details',
    component: ATATypeDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
    ],
    hidden: true,
  },
  {
    path: `${getACSATAProfileDetailsPatch}`,
    exact: true,
    name: 'ACS ATA Profile Details',
    component: ACSATAProfileDetails,
    allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
    hidden: true,
  },
  {
    path: `${getATAOrgTemplateDetailsPath}`,
    exact: true,
    name: 'ATA Org Template Details',
    component: ATAOrgTemplateDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
    ],
    hidden: true,
  },
  {
    path: `${getATABaseTemplateDetailsPath}`,
    exact: true,
    name: 'ATA Base Template Details',
    component: ATABaseTemplateDetails,
    requiredGlobalScope: 'equipment_ata_baseTemplate_read',
    hidden: true,
  },
  {
    path: getDialersBulkDetailsPath,
    exact: true,
    name: 'Dialers Bulk',
    component: DialersBulk,
    requiredOrgScope: 'equipment_dialer_bulkCreate',
    hidden: true,
  },
  {
    path: getDialerDetailsPath,
    exact: true,
    name: 'Dialer Details',
    component: DialerDetails,
    hidden: true,
  },
  {
    path: `${getPRIDeviceDetailsPath}`,
    exact: true,
    name: 'PRI Device Details',
    component: PRIDeviceDetails,
    hidden: true,
  },
  {
    path: `${getSmartphoneDetailsPath}`,
    exact: true,
    name: 'Smartphone Device Details',
    component: SmartphoneDetails,
    requiredOrgScope: 'equipment_smartphone_read',
    hidden: true,
  },
  {
    path: getEnclosuresBulkDetailsPath,
    exact: true,
    name: 'Enclosures Bulk',
    component: EnclosuresBulk,
    requiredOrgScope: 'equipment_enclosure_bulkCreate',
    hidden: true,
  },
  {
    path: getEnclosuresDetailsPath,
    exact: true,
    name: 'Enclosure Details',
    component: EnclosureDetails,
    hidden: true,
  },
  {
    path: getPowerCyclesBulkDetailsPath,
    exact: true,
    name: 'PowerCycle Bulk',
    component: PowerCyclesBulk,
    requiredOrgScope: 'equipment_powerCycle_bulkCreate',
    hidden: true,
  },
  {
    path: getPowerCyclesDetailsPath,
    exact: true,
    name: 'PowerCycle Details',
    component: PowerCycleDetails,
    hidden: true,
  },
  // CONNECTIVITY
  {
    path: getSimsDetailsPath,
    exact: true,
    name: 'SIM Details',
    component: SIMDetails,
    hidden: true,
  },
  {
    path: getFiberCircuitDetailsPath,
    exact: true,
    name: 'Fiber Circuit Details',
    component: FiberCircuitDetails,
    hidden: true,
  },
  {
    path: getStarlinkDetailsPath,
    exact: true,
    name: 'Starlink Circuit Details',
    component: StarlinkCircuitDetails,
    hidden: true,
  },
  {
    path: `${getDataPlanDetailsPath}`,
    exact: true,
    name: 'Data Plan Details',
    component: DataPlanDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    hidden: true,
  },
  {
    path: `${getDataPlanTypeDetailsPath}`,
    exact: true,
    name: 'Data Plan Type Details',
    component: DataPlanTypeDetails,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
    ],
    hidden: true,
  },
  // LEGAL
  {
    path: `${getLegalPage}`,
    exact: true,
    name: 'Legal',
    component: Legal,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
    ],
    hidden: true,
  },
  {
    path: `${getServiceLevelAgreementPage}`,
    exact: true,
    name: 'SLA',
    component: SLA,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
    ],
    hidden: true,
  },
  {
    path: `${getPricingPage}`,
    exact: true,
    name: 'Pricing',
    component: Pricing,
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
    ],
    hidden: true,
  },
  // SECURE ALARM
  {
    path: `${getSecureALARMManagerBucketDetails}`,
    exact: true,
    name: 'Secure Alarm Bucket Details',
    component: BucketDetails,
    allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
    hidden: true,
  },
  {
    path: `${getSecureALARMManagerDidsBulk}`,
    exact: true,
    name: 'Secure Alarm DIDs bulk',
    component: SecureAlarmDidsBulk,
    allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
    hidden: true,
  },
  // OTHER
  {
    path: getCountriesDetailsPath,
    exact: true,
    name: 'Country Details',
    component: CountryDetails,
    requiredGlobalScope: 'country_read',
    hidden: true,
  },
  {
    path: `${getULARECentralStationDetailsPath}`,
    exact: true,
    name: 'ULARE Central Station Details',
    component: ULARECentralStationDetails,
    allowedPermissionRoles: ulareCentralStationPermissions.READ,
    hidden: true,
  },
  {
    path: getIssueTrackerDetailsPath,
    exact: true,
    name: 'Issue Tracker Details',
    component: IssueTrackerDetails,
    requiredGlobalScope: 'issueTracker_read',
    hidden: true,
  },
  {
    path: '/inventory/fulfillment-orders/:id/logs',
    exact: true,
    name: 'Fulfillment Order Logs',
    component: FulfillmentOrderLogs,
    allowedPermissionRoles: fulfillmentOrderPermissions.READ,
    hidden: true,
  },
  {
    path: '/inventory/orders/:id/logs',
    exact: true,
    name: 'Order Logs',
    component: OrderLogs,
    allowedPermissionRoles: orderPermissions.READ,
    hidden: true,
  },
  {
    path: getPortingLogsPath,
    name: 'Port Request Logs',
    component: PortingLogs,
    exact: true,
    requiredOrgScope: 'port_request_read',
    hidden: true,
  },
  // MEGASWITCH DETAILS
  {
    path: `${getMegaswitchInstanceDetailsPath}`,
    exact: true,
    name: 'Megaswitch Instance Details',
    component: MegaswitchInstanceDetails,
    requiredGlobalScope: 'megaswitch_instance_read',
    hidden: true,
  },
  {
    path: `${getBillProfilesListPath}`,
    exact: true,
    name: 'Bill Profiles',
    component: BillProfilesList,
    allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud')],
    hidden: true,
  },
  {
    path: getBillProfileDetailsPath,
    exact: true,
    name: 'Bill Profile Details',
    component: BillProfileDetails,
    requiredGlobalScope: 'bill_profile_read',
    hidden: true,
  },
  {
    path: `${getBillingCredentialsListPath}`,
    exact: true,
    name: 'Billing Credentials',
    component: BillingCredentialsListPage,
    allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin],
    hidden: true,
  },
  {
    path: getOrgRoleDetailsPath,
    exact: true,
    name: 'Organization Role Details',
    component: OrgRoleDetails,
    allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
    hidden: true,
  },
  {
    path: getGlobalRoleDetailsPath,
    exact: true,
    name: 'Global Role Details',
    component: GlobalRoleDetails,
    allowedPermissionRoles: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
    hidden: true,
  },
  {
    path: '/',
    exact: true,
    pathTo: '/dashboard/noc',
    name: 'NOC',
    allowedPermissionRoles: [
      PERMISSIONROLECONSTANTS.superadmin,
      ...getAllPermissionRolesForUserLevel('telcloud'),
      ...getAllPermissionRolesForUserLevel('reseller'),
      ...getAllPermissionRolesForUserLevel('customer'),
    ],
    redirect: true,
  },
];
export default ThemeRoutes;
